import React, {useState,useEffect} from "react";
import { Accordion, Alert, Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { syncCategory, syncProduct } from "../../store/slices/dataSync";
import { syncStatus } from "../../store/slices/syncStatus";
import { storeLimit } from "../../store/slices/storeLimit";
import {previewSync} from "../../store/slices/previewSyncDetails"
import PreviewIcon from '@mui/icons-material/Preview';
import {parseShopifyHost} from '../../utils/parseShopifyHost';

const DataSync = ({ changeTab }) => {
  const dispatch = useDispatch();
  const productMapping = useSelector((state) => state.productMapping);
  const savedConfig = useSelector((state) => state.config.data);
  const storeHash = savedConfig?.targetClientDomain;
  const prodConfigId = useSelector(state => state.productMapping.configId);
  const channelMappingSave = useSelector((state) => state.dataFilters.finalData)
  const { categorySyncSuccess, productSyncSuccess, syncError, categoryStatus, productStatus } = useSelector((state) => state.dataSync);
  const [storeTrailLimit, updateStoreTrailLimit] = useState(false);
  const storeLimitData = useSelector((state)=>state.storeLimit.data);
  const isTrail = useSelector((state)=> state.storeLimit?.isTrail);
  const isTrailWebApp = useSelector((state)=> state.storeLimit?.isTrailWebApp);
  const trailDetails = useSelector((state)=>state.storeLimit?.trailDetails);
  const previewSyncDetails = useSelector((state)=>state.previewSyncDetail);
  const [showMsg, setShowMsg] = useState(false);
  const { isShopifyApp, shopName } = parseShopifyHost();

  const isEmptyObject = (obj) => {
    if(typeof obj ==="object"){
    return Object.keys(obj).length === 0 && obj.constructor === Object;
    }
  };

  const categorySyncStart = () => {
    if ((savedConfig?.basicFilter !== null && !isEmptyObject(savedConfig?.basicFilter) && (!isEmptyObject(savedConfig?.basicFilter?.dataFilter)))) {
      let storeHash = channelMappingSave?.targetClientDomain || savedConfig?.targetClientDomain;
      dispatch(syncCategory(storeHash)).unwrap().then(()=>{dispatch(storeLimit(storeHash))});
    } else {
      alert("Save the data filters & channel mappings before proceeding.");
    }
  };

  const productSyncStart = () => {
    if (
      (productMapping?.data !== null &&
        productMapping?.targetStoreHash !== null) ||
      savedConfig?.attributeMapping !== null
    ) {
      let storeHash =
        productMapping?.targetStoreHash !== null
          ? productMapping?.targetStoreHash
          : savedConfig?.targetClientDomain;
      dispatch(syncProduct(storeHash)).unwrap().then(()=>{dispatch(storeLimit(storeHash))});;
    } else {
      alert("Save the product data mapping before proceeding.");
    }
  };

  const syncPreview = () => {
    if (savedConfig !== null) {
      dispatch(previewSync(savedConfig?.struConfigId));
    } else if (prodConfigId !== null) {
      dispatch(previewSync(prodConfigId));
    }
  };

  const monitorStatus = () => {
    if (savedConfig !== null) {
      dispatch(syncStatus(savedConfig?.struConfigId));
    } else if (prodConfigId !== null) {
      dispatch(syncStatus(prodConfigId));
    }
    changeTab("sync-status")
  }


  useEffect(() => {
  if (previewSyncDetails.status === "Success") {
    setShowMsg(true);

    const timer = setTimeout(() => {
      setShowMsg(false);
    }, 10000); // 10 sec

    return () => clearTimeout(timer); // cleanup
  }
}, [previewSyncDetails.status]);

  const InfoIcon = () => (
    <svg
      className="bi flex-shrink-0 me-2"
      width="16"
      height="16"
      fill="currentColor"
      role="img"
      aria-label="Info:"
      viewBox="0 0 16 16"
    >
      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
    </svg>
  );


  useEffect(() => {
    const fetchStoreLimit = async () => {
      if (!storeHash) return;
            const availableCredits = parseInt(trailDetails?.allowedCredit, 10) || 0;
            const consumedCredits = parseInt(trailDetails?.usedCredit, 10) || 0;
            const remainingCredits = availableCredits - consumedCredits;
          // Handle the store limit logic immediately after fetching
          if(isTrailWebApp) {
            // Update trial limit status
            updateStoreTrailLimit(remainingCredits <= 0);
          }else if(isShopifyApp && isTrail){
            // Update trial limit status
            updateStoreTrailLimit(remainingCredits <= 0);
          } else {
            updateStoreTrailLimit(false);
          }
        }
    fetchStoreLimit();
      },[storeLimitData]);



  return (
    <div className="h-60">
      {syncError !== null &&
        <Alert variant="warning" className="d-flex align-items-center text-center mt-4 py-2 justify-content-center" style={{ fontSize: "14px" }} role="alert">
          <InfoIcon />
          <div>{syncError}</div>
        </Alert>
      }
      <Accordion defaultActiveKey={["1"]} alwaysOpen className="mt-5">
        <Accordion.Item eventKey="0" className="my-4">
          <Accordion.Header>Collection (category) Sync</Accordion.Header>
          <Accordion.Body className="px-5 py-4">
            <Row>
              <Col sm={12}>
                <Button
                  variant="primary"
                  type="submit"
                  className="stru-btn mb-3"
                  onClick={categorySyncStart}
                  disabled={storeTrailLimit}

                >
                  {categoryStatus == "Category Sync Inprogress" && <div className="spinner-border me-2" role="status" style={{ width: "18px", height: "18px" }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>}
                  Sync Collections
                </Button>
                <br />
                {(categoryStatus === "Category Sync Inprogress") && (
                  <>
                    <Button
                      type="button"
                      variant="primary"
                      className="job-link p-0 ms-2"
                      onClick={() => monitorStatus()}
                    >
                      <span
                        style={{
                          color: "#000",
                          textDecoration:"underline"
                        }}
                      >
                      Check your sync job status.
                      </span>
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1" className="my-4">
          <Accordion.Header>Product Sync</Accordion.Header>
          <Accordion.Body className="px-5 py-4">
            <Row>
              <Col sm={12}>
                <Button
                  variant="primary"
                  type="submit"
                  className="stru-btn mb-3 me-2"
                  onClick={productSyncStart}
                  disabled={storeTrailLimit}
                >
                  {productStatus == "Product Sync Inprogress" && <div className="spinner-border me-2" role="status" style={{ width: "18px", height: "18px" }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>}
                  Sync Products
                </Button>
                 <Button
                  variant="primary"
                  type="submit"
                  className="stru-btn mb-3 stru-btn test-conn"
                  onClick={syncPreview}
                  disabled={storeTrailLimit}
                >
                  {previewSyncDetails.status == "Loading" && <div className="spinner-border me-2" role="status" style={{ width: "18px", height: "18px" }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>}
                  Preview Sync
                </Button>
                
                {
                  (previewSyncDetails.status == "Success" && showMsg) && (<div className="previewDiv">
                    <PreviewIcon /><p className="previewSyncDetails">Estimated to sync {previewSyncDetails.data.data.Products} products and {previewSyncDetails.data.data.Variants} variants</p></div>
                  )
                }
                {(productStatus === "Product Sync Inprogress") && (
                  <>
                  <br/>
                    <Button
                      type="button"
                      variant="primary"
                      className="job-link p-0 ms-2"
                      onClick={() => monitorStatus()}
                    >
                      <span
                        style={{
                          color: "#000",
                          textDecoration:"underline"
                        }}
                      >
                        Check your sync job progress.
                      </span>
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          </Accordion.Body>
        </Accordion.Item>

        {storeTrailLimit && (
          <div className="fw-medium">
            <span className="bg-danger bg-opacity-50 p-1 px-2 rounded">Credits Exhausted, Contact{" "}
              <a className="text-decoration-underline hover:text-danger-emphasis">
                sales@striketru.com.
              </a>
            </span>
          </div>
        )}


      </Accordion>
    </div>
  );
};

export default DataSync;